module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABS0lEQVRYhe2Y0Q7DIAhFcdl/t/1y9rCaUUVFAbcunqRJayl6BdkUYLFQEWovEbHtIIS2Ue632m+lr6ztOeIoRSKUDiKEgKMiUh4WTnpBxKHIcXxFAICdCHcBx3FkbWcaxXuViCkRoCIQ8XJpMalCnB0389u2cd+LqxJXhaqks8Vdb7Mr+75f7ulzyvm9tK+MKSnEzbwV7gI8B99kNIVKcKkEv55C3GK2xFWA9+AB/qCMugkA+IioLWStANcUmlGBXCMgGsAvR2AGJhua7v8ohqgFSMPvxe1T6PYCWuHPyktHxUBNenHfD51KME6aA7M8dWhx+xRSVyG6KaezHqMQ38d3Nfu0rdYuBdOL2Qtkz7S9dN+yT/sDZj0CGKyB3mMRzj5GChED9S2Z9ek/ZCV7KqLHn+kiHo0GzfNeH6oIpB22Zq9kzy32xWIh4wWINwKlUUO1lgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IERFSH.png
// module id = 73
// module chunks = 0